import { HttpClient } from '../httpClient';
import EsyRequest from '../requests/esyRequest';
import EsyResponse from '../responses/esyResponse';
import EsysResponse from '../responses/esysResponse';
import { BaseResponse } from '../responses/baseResponse';

const httpClient = new HttpClient();

export const getEsys = async () => {
  return httpClient.get<EsysResponse>({
    url: '/v1/esys',
    requiresToken: true,
  });
};

export const getEsy = async (esyId: number) => {
  return httpClient.get<EsyResponse>({
    url: `/v1/esys/${esyId}`,
    requiresToken: true,
  });
};

export const getDivisionEsys = async (divisionId: number) => {
  return httpClient.get<EsysResponse>({
    url: `/v1/esys/bydivision/${divisionId}`,
    requiresToken: true,
  });
};

export const createEsy = async (esyrequest: EsyRequest) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/admin/esys',
    payload: esyrequest,
    requiresToken: true,
  });
};

export const updateEsy = async (esyId: number, esyrequest: EsyRequest) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/esys/${esyId}`,
    payload: esyrequest,
    requiresToken: true,
  });
};

export const deleteEsy = async (esyId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/esys/${esyId}`,
    requiresToken: true,
  });
};
